import { UploadOutlined } from '@ant-design/icons';
import { useDispatch } from '@redux';
import { Button, Upload } from 'antd';
import { RcFile } from 'antd/es/upload';
import { getUrl, uploadMedia } from 'api/upload';
import { LINK_TEMPLATES } from 'constants/constants';
import { UploadRequestOption } from 'rc-upload/lib/interface';
import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DynamicObjectType } from 'types/commons';

const UploadFileButton = (
  {
    next,
    setLoadingImport,
    setJobId,
    setDisabled,
    importActions,
    source,
    extraContent,
    extraRef,
  }: {
    next: () => void;
    setLoadingImport: (value: boolean) => void;
    setJobId: (value: string) => void;
    setDisabled: (value: boolean) => void;
    // eslint-disable-next-line
    importActions: any;
    source?: string;
    extraContent?: React.ReactNode;
    // eslint-disable-next-line
    extraRef?: any;
  },
  ref,
) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState<boolean>(false);
  const [path, setPath] = useState<string>('');

  useImperativeHandle(
    ref,
    () => ({
      import: () => handleImport(),
    }),
    [path],
  );

  const customRequest = async ({ onSuccess, file }: UploadRequestOption) => {
    setLoading(true);

    const responseS3 = await getUrl(
      (file as RcFile)?.name || '',
      (file as RcFile).type,
    );
    const xhr = await uploadMedia(responseS3.uploadUrl, file);

    if (xhr) {
      onSuccess(responseS3.name, xhr);
    }
  };

  const onChangeUpload = (e) => {
    setLoading(true);
    let isUploaded = true;
    setPath(e?.file?.response);
    if (e?.file?.status !== 'done') {
      isUploaded = false;
    }
    isUploaded && setLoading(false);
    isUploaded && setDisabled(false);
  };

  const handleImport = async () => {
    setLoadingImport(true);
    await dispatch(
      importActions({
        data: {
          filePath: path,
          type: extraRef && extraRef?.current?.value,
        },
        options: {},
      }),
    )
      .then(({ payload }: DynamicObjectType) => {
        if (payload?.error) {
          setLoadingImport(false);
          setDisabled(false);
          return;
        }
        if (payload.jobId) {
          setLoadingImport(false);
          setDisabled(false);
          setJobId(payload.jobId);
          next();
        }
      })
      .catch(() => {
        setLoadingImport(false);
        setDisabled(false);
      });
  };

  return (
    <>
      <Upload
        customRequest={customRequest}
        className="avatar-uploader"
        onChange={onChangeUpload}
        accept=".xlsx"
      >
        <Button icon={<UploadOutlined />} loading={loading}>
          {t('button.uploadFile')}
        </Button>
      </Upload>
      <div className="mt-[10px]">
        {t('locationStocks.downloadLabel')}
        &nbsp;
        <span
          className="pointer text-highlight "
          onClick={() =>
            window
              .open(
                `${source ? LINK_TEMPLATES[source] : 'https://lighto.s3.amazonaws.com/template/import-order.xlsx'}`,
                '_blank',
                'noopener,noreferrer',
              )
              ?.focus()
          }
        >
          here
        </span>
      </div>
      <div className="mt-[10px]">{extraContent}</div>
    </>
  );
};

export default forwardRef(UploadFileButton);
